export enum ALARMS {
  supplyAirSensorDefault = 1,
  returnAirSensorDefault = 2,
  lowRssi = 3,
  compressorBypass = 4,
  highTemperature = 5,
  lowTemperature = 6,
  compressorMalfunction = 7,
  SerialInterfaceError = 8,
  muxDeviceIdForRoomIdIssue = 9,
  controllerNotFound = 10,
  rtcDrift = 11,
  nonZeroAcFaultCode = 12
}

export const ALARMS_MAPPING = {
  [ALARMS.supplyAirSensorDefault]: 'Supply Air Sensor',
  [ALARMS.returnAirSensorDefault]: 'Return Air Sensor',
  [ALARMS.lowRssi]: 'Weak WiFi',
  [ALARMS.compressorBypass]: 'Compressor Bypass',
  [ALARMS.highTemperature]: 'High Temperature',
  [ALARMS.lowTemperature]: 'Low Temperature',
  [ALARMS.compressorMalfunction]: 'Compressor Malfunction',
  [ALARMS.SerialInterfaceError]: 'Serial Interface Error',
  [ALARMS.muxDeviceIdForRoomIdIssue]: 'Mux Device ID for Room ID Issue',
  [ALARMS.controllerNotFound]: 'Controller Not Found',
  [ALARMS.rtcDrift]: 'RTC Drift',
  [ALARMS.nonZeroAcFaultCode]: 'AC Fault Code'
};

export enum ROOM_MODAL_TAB_KEYS {
  Data = 'Data',
  Alarm = 'Alarm',
  Measurements = 'Measurements',
  Temperature = 'Temperature',
  Power = 'Power'
}

export const TIME_AND_DATE_FORMATS = {
  FULL_DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
  DAY_MONTH_DATE_YEAR_SHORTED_FORMAT: 'ddd, MMM D, YYYY',
  DAY_MONTH_DATE_YEAR_TIME_SHORTED_FORMAT: 'llll',
  MONTH_DATE_YEAR_FORMAT: 'll'
};

export const TEMP_ENERGY_SHORTCUTS = {
  TEMPERATURE: '°C',
  ENERGY: 'W'
};

export const REPORT_TAB_CSV_HEADERS = [
  'temp1',
  'fanTime',
  'coolingEnergy',
  'comprTime',
  'presenceTime',
  'referenceConsumption',
  'conTime',
  'buildingName',
  'levelName',
  'roomName',
  'energy'
];

export const ROOM_MODAL_TAB_CSV_HEADERS = [
  'compTime',
  'coolingEnergy',
  'date',
  'devId',
  'dt',
  'energy',
  'fanTime',
  'hum',
  'presenceTime',
  'relay',
  'roomId',
  'roomTemp',
  'airSupplyTemp'
];

export const CSV_MAPPING = {
  temp1: 'Avg temperature [°C]',
  fanTime: 'Fan running time',
  coolingEnergy: 'Cooling energy [kWh]',
  compTime: 'Compressor time',
  presenceTime: 'Presence time',
  referenceConsumption: 'Reference consumption [kWh]',
  conTime: 'Connection time',
  buildingName: 'Building name',
  levelName: 'Level name',
  roomName: 'Room name',
  energy: 'Energy [kWh]',
  devId: 'Device ID',
  date: 'Created at',
  dt: 'Date time',
  hum: 'humidity',
  relay: 'relay',
  roomId: 'Room ID',
  roomTemp: 'Room temperature [°C]',
  airSupplyTemp: 'Supply air temperature [°C]'
};

export const PAGE_SIZE_OPTIONS = [5, 10, 25, 100, 1000];
export const DEFAULT_PAGINATION_LIMIT = 10;
export const DEFAULT_PAGE = 1;
export const DEFAULT_ROOMS_REPORT_FILTRATION = {
  temp1: 0,
  fanTime: 0,
  activeEnergy: 0,
  alarmsCount: 0,
  lastActiveAt: -1
};

export const EMPTY_ROOMS_REPORT_FILTRATION = {
  ...DEFAULT_ROOMS_REPORT_FILTRATION,
  lastActiveAt: 0
};

export enum SORT {
  ASC = 'ascend',
  DESC = 'descend'
}

export enum ORDER {
  NONE = 0,
  ASC = 1,
  DESC = -1
}

export const ORDER_MAPPING = {
  [SORT.ASC]: ORDER.ASC,
  [SORT.DESC]: ORDER.DESC
};

export const DUBAI_TZ = +4;

export const OPERATIONS_CONTROL = {
  SOFT_CONTROL_WITH_NEITHER_SWITCH_ON_OR_SWITCH_OFF: 'Soft control with neither switch on nor switch off',
  SOFT_CONTROL_WITH_START_ONLY: 'Soft control with start only',
  SOFT_CONTROL_WITH_SWITCH_OFF_ONLY: 'Soft control with switch off only',
  SOFT_CONTROL_FOR_BOTH_SWITCH_ON_AND_OFF: 'Soft control for both switch on and off',
  HARD_CONTROL: 'Hard control'
};

export const OPERATIONS_CONTROL_MAPPING = [
  OPERATIONS_CONTROL.SOFT_CONTROL_WITH_NEITHER_SWITCH_ON_OR_SWITCH_OFF,
  OPERATIONS_CONTROL.SOFT_CONTROL_WITH_START_ONLY,
  OPERATIONS_CONTROL.SOFT_CONTROL_WITH_SWITCH_OFF_ONLY,
  OPERATIONS_CONTROL.SOFT_CONTROL_FOR_BOTH_SWITCH_ON_AND_OFF,
  OPERATIONS_CONTROL.HARD_CONTROL
];

// helper constants for the new operation policy table
export const SETPOINT_MODES = ['Normal', 'Setback'];

export const SETPOINT_MODE = {
  NORMAL: 0,
  SETBACK: 1
};

export const INACTIVITY_TIMER = {
  TRESHOLD: 1800000,
  TIMEOUT: 60000
};
